const sessionStates = {
  AUTH_USER_SET_OR_UPDATE: 'AUTH_USER_SET_OR_UPDATE',
  ORG_ID_SET_OR_UPDATE: 'ORG_ID_SET_OR_UPDATE',
  SELECTED_PRODUCT_SET_OR_UPDATE: 'SELECTED_PRODUCT_SET_OR_UPDATE',
  USER_ACCESS_SET_OR_UPDATE: 'USER_ACCESS_SET_OR_UPDATE',
};

export default sessionStates;
